import { NgModule } from '@angular/core';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DataTablesModule } from 'angular-datatables';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { Daterangepicker } from 'ng2-daterangepicker';
import { FormsModule } from '@angular/forms';
import { Dashboard1Component } from './dashboard1/dashboard1.component';
import { DashboardDetailComponent } from './dashboard-detail/dashboard-detail.component';
import { DashboardFilterComponent } from './dashboard-filter/dashboard-filter.component';
// import {SearchFilterModule} from '../../_custom/search-filter/search-filter.module';
import { PieChartModule } from '../../_custom/pie-chart/pie-chart.module';
import { LineChartModule } from '../../_custom/line-chart/line-chart.module';
import { SemiPieChartModule } from 'app/_custom/semi-pie-chart/semi-pie-chart.module';
import { Routes, RouterModule } from '@angular/router';
import { Dashboard2Component } from './dashboard2/dashboard2.component';
import { SharedModule } from 'app/_shared/shared.module';
import { LaddaModule } from 'angular2-ladda';
import { LoaderServiceComponent } from './loader-service/loader-service.component';
// import { AuthViewDashboard1Guard, AuthViewDashboard2Guard, AuthViewDashboard3Guard, AuthViewDashboard4Guard } from 'app/_guards/auth-report.guard';
import { Dashboard3Component } from './dashboard3/dashboard3.component';
import { Dashboard4Component } from './dashboard4/dashboard4.component';
import { AuthPermissionGuard } from 'app/_guards/auth-permission.guard';
import { ConfigPermissionOption } from 'app/_helpers/config-permission-option';
import { Dashboard5Component } from './dashboard5/dashboard5.component';
import { Dashboard6Component } from './dashboard6/dashboard6.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { VietnamMapModule } from 'app/_custom/vietnam-map/vietnam-map.module';
import { Dashboard7Component } from './dashboard7/dashboard7.component';
import { Dashboard8Component } from './dashboard8/dashboard8.component';



@NgModule({
  imports: [
    NgxPaginationModule,
    TabsModule,
    CommonModule,
    DataTablesModule,
    HttpClientModule,
    AngularMultiSelectModule,
    Daterangepicker,
    FormsModule,
    // SearchFilterModule,
    PieChartModule,
    SharedModule,
    LaddaModule,
    SemiPieChartModule,
    LineChartModule,
    VietnamMapModule,
    RouterModule.forChild([
      {
        path: 'tong-quan-chu-de',
        component: Dashboard1Component,
        canActivate: [AuthPermissionGuard],
        data:{
          permission:ConfigPermissionOption.actionViewDashboard1,
          title: 'dashboard1'
        }
      },
      {
        path: 'dashboard-detail',
        component: DashboardDetailComponent,
        canActivate: [AuthPermissionGuard],
        data:{
          permission:ConfigPermissionOption.actionViewDashboardDetail,
          title: 'dashboard-detail'
        }
      },
      {
        path: 'diem-tin-theo-chu-de',
        component: Dashboard2Component,
        canActivate: [AuthPermissionGuard],
        data:{
          permission:ConfigPermissionOption.actionViewDashboard2,
          title: 'dashboard2'
        }
      },
      {
        path: 'so-sanh-thuong-hieu',
        component: Dashboard3Component,
        canActivate: [AuthPermissionGuard],
        data:{
          permission:ConfigPermissionOption.actionViewDashboard3,
          title: 'Dashboard3'
        }
      },
      {
        path: 'thuong-hieu-doi-thu',
        component: Dashboard4Component,
        canActivate: [AuthPermissionGuard],
        data:{
          permission:ConfigPermissionOption.actionViewDashboard4,
          title: 'Dashboard4'
        }
      },
      {
        path: 'noi-dung-noi-bat',
        component: Dashboard5Component,
        canActivate: [AuthPermissionGuard],
        data:{
          permission:ConfigPermissionOption.actionViewDashboard1,
          title: 'Dashboard5'
        }
      },
      {
        path: 'painpoint',
        component: Dashboard6Component,
        canActivate: [AuthPermissionGuard],
        data:{
          permission:ConfigPermissionOption.actionViewDashboard1,
          title: 'Dashboard6'
        }
      },
      {
        path: 'hashtag',
        component: Dashboard7Component,
        canActivate: [AuthPermissionGuard],
        data:{
          permission:ConfigPermissionOption.actionViewDashboard1,
          title: 'Dashboard7'
        }
      },
      {
        path: 'so-sanh-thuong-hieu-doi-thu',
        component: Dashboard8Component,
        canActivate: [AuthPermissionGuard],
        data:{
          permission:ConfigPermissionOption.actionViewDashboard1,
          title: 'Dashboard7'
        }
      }
    ])
  ],
  declarations: [
    Dashboard1Component,
    Dashboard2Component,
    Dashboard3Component,
    Dashboard4Component,
    Dashboard5Component,
    Dashboard6Component,
    Dashboard7Component,
    Dashboard8Component,
    DashboardFilterComponent,
    DashboardDetailComponent,
    LoaderServiceComponent
  ],
  providers: []

})

export class DashboardsModule {
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboards.module.ts